import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { Space } from '@components/atoms/Space';

interface ResultsPageTopProps {
    searchQuery: string;
}

export const SearchResultsHeader: FC<ResultsPageTopProps> = ({ searchQuery }) => {
    const { t } = useTranslation();

    const translations = {
        resultsLabel: t('search-results-header-component.results-label'),
    };

    return (
        <div data-testid="search-results-header">
            <Space spaceBreakpoints={{ xs: { space: 50 } }} />
            <Typography tagVariant={TypographyTagVariants.h1} fontSize="20" classes="mb-0">
                <>
                    {translations.resultsLabel}
                    <Typography tagVariant={TypographyTagVariants.span} fontWeight="800">{` "${searchQuery}"`}</Typography>
                </>
            </Typography>
            <Space spaceBreakpoints={{ xs: { space: 50 } }} />
            <hr className="mt-0 mb-4 mb-lg-5" />
        </div>
    );
};
